import { useQuery } from "@tanstack/react-query"
import { getBackofficeCanonicalTopicsGroupedQuery } from "modules/backoffice/lib/canonicalTopics/getBackofficeCanonicalTopicsGroupedQuery"

export function useBackofficeCanonicalTopicsGroupedQuery(
  ...args: Parameters<typeof getBackofficeCanonicalTopicsGroupedQuery>
) {
  return useQuery(getBackofficeCanonicalTopicsGroupedQuery(...args))
}
